import { getDevices } from "../skylineApi"
import { bindData, byId } from "../utils"
import * as adminFeed from "../adminFeed"

const root = byId("devicesTab")
const deviceViewE = byId("deviceListView")
const devicesTab = root.content.cloneNode(true).firstElementChild
let deviceListE

function addDevice(device, root, before) {
	const newEntry = deviceViewE.content.cloneNode(true).firstElementChild
	newEntry.href = "/devices/" + device.id
	newEntry.querySelector(".deviceImage").src = device.type == "ARS" ? "/images/ars-gray.png" : "/images/Inactive GRS.png"
	newEntry.querySelector(".wifiIcon").dataset.feather = device.state != "DISCONNECTED" ? "wifi" : "wifi-off"
	bindData(device, newEntry)
	newEntry.dataset.did = device.id
	newEntry.dataset.isActive = device.state !== 'DISCONNECTED'
	return newEntry
}

function placeNode(node, device) {
	let devices = Array.from(deviceListE.querySelectorAll(".deviceEntry:not(.deviceListHeader)"))
	devices = devices.filter(e => node.dataset.isActive === e.dataset.isActive) 
	let before = devices.find(e => e.querySelector(".deviceName").textContent.localeCompare(device.name) > 0)
	if (!before && devices.length) before = devices[devices.length-1].nextSibling
	deviceListE.insertBefore(node, before)
}

function handleAdminFeed(entry) {
	if (!entry.device) {
		console.error("Got an admin feed without a device", entry)
		return
	}

	if (!deviceListE) return

	switch (entry.action) {
	case "CREATE":
	{
		const newEntry = addDevice(entry.device, deviceListE)
		placeNode(newEntry, entry.device)
		break
	}
	case "UPDATE":
	{
		const E = deviceListE.querySelector(`[data-did="${entry.device.id}"]`)
		if (!E) {
			console.error("We are missing a device to update", entry)
			return
		}
		bindData(entry.device, E)
		placeNode(E, entry.device)
		break
	}
	case "DELETE":
	{
		const E = deviceListE.querySelector(`[data-did="${entry.device.id}"]`)
		deviceListE.removeChild(E)
		break
	}
	default:
		console.error("Got an unexpected ation in admin feed", entry)
	}
}

export default function index(app) {
	app.router.on('/devices', (match) => {

		adminFeed.register("device", handleAdminFeed)

		const contentE = devicesTab.getElementsByClassName("deviceTabContent")[0]
		while (contentE.firstChild) {
			contentE.removeChild(contentE.firstChild)
		}
		deviceListE = byId("devicesList").content.cloneNode(true).firstElementChild
		contentE.appendChild(deviceListE)
		const devices = Object.values(getDevices())
		for (const device of devices) {
			let newEntry = addDevice(device, deviceListE)
			placeNode(newEntry, device)
		}
		app.setContent(devicesTab, () => {
			const map = document.getElementById('mapid')
			map.style.marginTop = ''
			map.style.height = ''
			deviceListE = null
			adminFeed.unregister("device", handleAdminFeed)
		})

		const map = document.getElementById('mapid')
		map.style.marginTop = '50vh'
		map.style.height = 'calc(50vh - 40px)'
	})
}